$ = jQuery;

import Swiper from 'swiper';
import { Pagination, Autoplay, EffectCards, Scrollbar, Navigation, Thumbs } from 'swiper/modules';
//import Isotope from 'isotope-layout';

//import {header} from './modules/header';


$(document).ready(function() {
  


  /* ################################# */
  /* ###### START: INTERACTIONS ###### */
  /* ################################# */

  /* ####################################### */
  /* ### START INTERACTIONS - GENERAL    ### */
  /* ####################################### */

  /* START: HAMBURGER MENU */
  $(document).on("click", "header .hamburger", function () {
    let burger = $(this);
    let cart = $('.sidebar-wrapper.cart');
    let nav = $('.nav-wrapper nav ul');
    let header = $('header');
    let subHeader = $('.sub-header-wrapper');

    if(burger.hasClass('is-active')){
      if(!cart.hasClass('closed')){
        cart.addClass('closed');
      }
      burger.removeClass('is-active');
      nav.removeClass('open');
      header.removeClass('open');
      subHeader.removeClass('hidden');
    }else{
      burger.addClass('is-active');
      nav.addClass('open');
      header.addClass('open');
      subHeader.addClass('hidden');
    }
  });
  /* END: HAMBURGER MENU */

  /* START: TOGGLE CART */
  $(document).on("click", ".sidebar-cover", function () {
    let cart = $('.sidebar-wrapper.cart');
    let header = $('header');
    let burger = $('header .hamburger');
    cart.addClass('closed');
    header.removeClass('open');
    burger.removeClass('is-active');
  });
  $(document).on("click", ".cart-toggle", function () {
    let burger = $('header .hamburger');
    let cart = $('.sidebar-wrapper.cart');
    let header = $('header');
    let nav = $('.nav-wrapper nav ul');
    let subHeader = $('.sub-header-wrapper');

    if (header.hasClass('open')){
      header.removeClass('open');
      nav.removeClass('open');
      cart.removeClass('closed');
      burger.addClass('is-active');
      subHeader.removeClass('hidden');
    }else{
      cart.removeClass('closed');
      burger.addClass('is-active');
      subHeader.addClass('hidden');
    }
  });
  $(document).on("click", ".sidebar-wrapper .close-sidebar", function () {
    $(this).closest('.sidebar-wrapper').addClass('closed');
  });
  /* END: TOGGLE CART */


   /* START: SIDEBAR CONTACT */
    $(document).on("click", ".btn-main.nb-product-contact", function () {

        let $btn = $(this);
        let $sidebar = $('.sidebar-wrapper.contact');
        
        // Populate hidden fields
        $sidebar.find('input[name="product-name"]').val($btn.data('product-name'));
        $sidebar.find('input[name="product-sku"]').val($btn.data('product-sku'));
        $sidebar.find('input[name="product-url"]').val($btn.data('product-url'));
        $sidebar.toggleClass('closed');
    });
    /* END: SIDEBAR CONTACT */


  /* START: FAQ SECTION */
  $(document).on("click", "section .faq .question-wrapper", function () {
    $(this).siblings().removeClass('open');
    $(this).toggleClass('open');
  });
  /* END: FAQ SECTION */

  /* ####################################### */
  /* ### END   INTERACTIONS - GENERAL    ### */
  /* ####################################### */





  /* ####################### */
  /* ### START SWIPER    ### */
  /* ####################### */
  /* Single-product-image swiper */
  if($('.product-swiper .product-swiper-main').length){
    const mainSwiperEl = document.querySelector('.product-swiper .product-swiper-main');
    const slideCount = mainSwiperEl ? mainSwiperEl.querySelectorAll('.swiper-slide').length : 0;
    const hasMultipleSlides = slideCount > 1;

    // Thumbs swiper (only created when there are multiple images)
    let thumbsSwiper = null;
    if (hasMultipleSlides && $('.product-swiper-thumbs').length) {
      thumbsSwiper = new Swiper('.product-swiper-thumbs', {
        modules: [Navigation],
        slidesPerView: 'auto',
        spaceBetween: 8,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
      });
    }

    // Main swiper
    const productSwiper = new Swiper('.product-swiper-main', {
      modules: [Navigation, Autoplay, Thumbs],
      slidesPerView: 1,
      spaceBetween: hasMultipleSlides ? 32 : 0,
      loop: hasMultipleSlides,
      autoplay: hasMultipleSlides ? {
        delay: 5000,
        disableOnInteraction: true,
      } : false,
      navigation: hasMultipleSlides ? {
        nextEl: '.product-swiper .swiper-button-next',
        prevEl: '.product-swiper .swiper-button-prev',
      } : false,
      thumbs: thumbsSwiper ? {
        swiper: thumbsSwiper,
      } : undefined,
    });
  }

  /* Referanse swiper */
  if($('.ref-slider .swiper').length){
    const refSwiper = new Swiper('.ref-slider .swiper', {
      modules: [EffectCards],
      effect: "cards",
      grabCursor: true,
      cardsEffect: {
        rotate: false,
        perSlideOffset: 10, // Adjusts how much cards "stack" (default: 8)
        perSlideRotate: 0, // Ensures no sneaky rotation
      },
      speed: 300, // Smoother transitions
      simulateTouch: true, // Ensures touch works
      allowTouchMove: true, // Explicitly allows swiping
    });
  }


  /* HERO SWIPER */
  if ($('.hero-swiper').length) {
    const heroSwiper = new Swiper('.hero-swiper', {
        modules: [Pagination, Autoplay, Navigation],
        loop: true,
        autoplay: {
            delay: 5000, // 5 seconds per slide
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        speed: 600,
        on: {
            // When autoplay starts or slide changes
            autoplayStart: function() {
                updatePaginationProgress(this);
            },
            slideChange: function() {
                updatePaginationProgress(this);
            },
        },
    });

    // Function to update pagination progress
    function updatePaginationProgress(swiper) {
        // Reset all bullets by removing the filling class
        $('.swiper-pagination-bullet').removeClass('filling');

        // Get the active bullet
        const $activeBullet = $('.swiper-pagination-bullet-active');
        if ($activeBullet.length) {
            // Set the transition duration as a CSS custom property
            const autoplayDelay = swiper.params.autoplay.delay;
            $activeBullet.css('--fill-duration', `${autoplayDelay}ms`);
            // Add the filling class to trigger the animation
            $activeBullet.addClass('filling');
        }
    }
  }


  /* ####################### */
  /* ### END   SWIPER    ### */
  /* ####################### */



  /* ####################### */
  /* ### START LIGHTBOX  ### */
  /* ####################### */
  if($('#referanser-lightbox').length){
    var $items = $('.referanse-item');
    var $lightbox = $('#referanser-lightbox');
    var $closeBtn = $lightbox.find('.lightbox-close');
    var $prevBtn = $lightbox.find('.lightbox-prev');
    var $nextBtn = $lightbox.find('.lightbox-next');
    var currentIndex = -1;

    // Store all post data in an array
    var posts = $items.map(function() {
        var $this = $(this);
        return {
            id: $this.data('post-id'),
            image: $this.find('.ref-image').attr('src'), // Use img src instead of background
            title: $this.find('.ref-title').text(),
            place: $this.find('.ref-place').text(),
            desc: $this.find('.ref-desc').text()
        };
    }).get();

    // Open lightbox on item click
    $items.on('click', function() {
        currentIndex = $items.index(this);
        updateLightbox();
        $lightbox.css('display', 'flex');
    });

    // Close lightbox
    $closeBtn.on('click', function() {
        $lightbox.hide();
    });

    // Navigate to previous
    $prevBtn.on('click', function() {
        currentIndex = (currentIndex - 1 + posts.length) % posts.length; // Loop back
        updateLightbox();
    });

    // Navigate to next
    $nextBtn.on('click', function() {
        currentIndex = (currentIndex + 1) % posts.length; // Loop forward
        updateLightbox();
    });

    // Update lightbox content
    function updateLightbox() {
        var post = posts[currentIndex];
        $lightbox.find('.lightbox-image').attr('src', post.image); // Update img src
        $lightbox.find('.lightbox-image').attr('alt', post.title); // Update alt text
        $lightbox.find('.lightbox-title').text(post.title);
        $lightbox.find('.lightbox-place').text(post.place);
        $lightbox.find('.lightbox-desc').text(post.desc);
    }

    // Close on outside click
    $lightbox.on('click', function(e) {
        if (e.target === this) {
            $lightbox.hide();
        }
    });
  }
  /* ####################### */
  /* ### END LIGHTBOX  ### */
  /* ####################### */




  /* ################################## */
  /* ### START SUB-HEADER-OVERFLOW  ### */
  /* ################################## */
  if($('.sub-header-menu').length){
    var $scrollContainer = $('.sub-header-menu');
    var $leftIndicator = $('.indicator-row .left');
    var $rightIndicator = $('.indicator-row .right');

    // Function to update indicator visibility
    function updateIndicators() {
        if ($(window).width() >= 992) {
            // Above 992px, keep SVGs hidden
            $leftIndicator.hide();
            $rightIndicator.hide();
            return;
        }

        var scrollLeft = $scrollContainer.scrollLeft();
        var scrollWidth = $scrollContainer[0].scrollWidth; // Use [0] to access native element
        var clientWidth = $scrollContainer[0].clientWidth;

        // Show left arrow if scrolled past the start
        if (scrollLeft > 0) {
            $leftIndicator.show();
        } else {
            $leftIndicator.hide();
        }

        // Show right arrow if not scrolled to the end
        if (scrollLeft + clientWidth < scrollWidth) {
            $rightIndicator.show();
        } else {
            $rightIndicator.hide();
        }
    }

    // Bind events if scroll container exists
    if ($scrollContainer.length) {
        $scrollContainer.on('scroll', updateIndicators);
        $(window).on('resize', updateIndicators);
        updateIndicators(); // Initial check
    }
  }
  /* ################################## */
  /* ### END   SUB-HEADER-OVERFLOW  ### */
  /* ################################## */


  /* ################################## */
  /* ### START CONTACT FORM EMAIL    ### */
  /* ################################## */
  // Unscramble email addresses to prevent spam bot harvesting
  $('[data-email-scrambled]').each(function() {
    var $emailLink = $(this);
    var scrambledEmail = $emailLink.attr('data-email-scrambled');
    // Reverse the scrambled email back to original
    var unscrambledEmail = scrambledEmail.split('').reverse().join('');
    // Update the href with the unscrambled email
    $emailLink.attr('href', 'mailto:' + unscrambledEmail);
    // Remove the data attribute for cleanliness
    $emailLink.removeAttr('data-email-scrambled');
  });
  /* ################################## */
  /* ### END   CONTACT FORM EMAIL    ### */
  /* ################################## */







  /* ############################## */
  /* ###### START: FRESHCHAT ###### */
  /* ############################## */
  /* ----FLYTTET TIL FOOTER.PHP---- */
  /* ############################## */
  /* ###### END:   FRESHCHAT ###### */
  /* ############################## */


   


    function repaintCart(response) {
      if (response.success) {
          $(".sidebar-wrapper.cart .sidebar .inner").html(response.data.content);
          $(".cart-toggle .cart-qty").html(response.data.qty);
      } else {
          console.error('Error:', response.data.message);
      }
    }
  
    $(document).on('click', '.remove-item', function(e) {
      e.preventDefault();
      var $cartItem = $(this).closest('.cart-item');
      var cartItemKey = $cartItem.data('attr-cart-item-key');

      $.ajax({
          url: wc_add_to_cart_params_2.ajax_url,
          type: 'POST',
          dataType: "json",
          data: {
              action: 'nb_remove_cart_item',
              cart_item_key: cartItemKey,
              nonce: wc_add_to_cart_params_2.nonce
          },
          beforeSend: function() {
              $cartItem.addClass('loading');
          },
          success: function(response) {
              repaintCart(response);
          },
          complete: function() {
              $cartItem.removeClass('loading');
          }
      });
  });

  // Increase quantity
  $(document).on('click', '.plus', function(e) {
      e.preventDefault();
      var $cartItem = $(this).closest('.cart-item');
      var cartItemKey = $cartItem.data('attr-cart-item-key');
      var $qtyInput = $cartItem.find('.qty');
      var currentQty = parseInt($qtyInput.val());
      var newQty = currentQty + 1;

      $.ajax({
          url: wc_add_to_cart_params_2.ajax_url,
          type: 'POST',
          dataType: "json",
          data: {
              action: 'nb_update_cart_quantity',
              cart_item_key: cartItemKey,
              quantity: newQty,
              nonce: wc_add_to_cart_params_2.nonce
          },
          beforeSend: function() {
              $cartItem.addClass('loading');
          },
          success: function(response) {
              repaintCart(response);
          },
          complete: function() {
              $cartItem.removeClass('loading');
          }
      });
  });

  // Decrease quantity
  $(document).on('click', '.minus', function(e) {
      e.preventDefault();
      var $cartItem = $(this).closest('.cart-item');
      var cartItemKey = $cartItem.data('attr-cart-item-key');
      var $qtyInput = $cartItem.find('.qty');
      var currentQty = parseInt($qtyInput.val());
      var newQty = currentQty - 1;

      if (newQty < 1) return; // Prevent going below 1

      $.ajax({
          url: wc_add_to_cart_params_2.ajax_url,
          type: 'POST',
          dataType: "json",
          data: {
              action: 'nb_update_cart_quantity',
              cart_item_key: cartItemKey,
              quantity: newQty,
              nonce: wc_add_to_cart_params_2.nonce
          },
          beforeSend: function() {
              $cartItem.addClass('loading');
          },
          success: function(response) {
              repaintCart(response);
          },
          complete: function() {
              $cartItem.removeClass('loading');
          }
      });
  });

  // Optional: Manual quantity input change
  $(document).on('change', '.qty', function() {
      var $cartItem = $(this).closest('.cart-item');
      var cartItemKey = $cartItem.data('attr-cart-item-key');
      var newQty = parseInt($(this).val());

      if (newQty < 1) {
          $(this).val(1);
          newQty = 1;
      }

      $.ajax({
          url: wc_add_to_cart_params_2.ajax_url,
          type: 'POST',
          dataType: "json",
          data: {
              action: 'nb_update_cart_quantity',
              cart_item_key: cartItemKey,
              quantity: newQty,
              nonce: wc_add_to_cart_params_2.nonce
          },
          beforeSend: function() {
              $cartItem.addClass('loading');
          },
          success: function(response) {
              repaintCart(response);
          },
          complete: function() {
              $cartItem.removeClass('loading');
          }
      });
  });


  $(document).on('click', '.nb-add-to-cart', function(e) {
    e.preventDefault();
    var $button = $(this);
    var productId = $button.attr('data-attr-product-id');
    var quantity = 1; // Optional: Get quantity from an input

    $.ajax({
        url: wc_add_to_cart_params_2.ajax_url,
        type: 'POST',
        dataType: "json",
        data: {
            action: 'nb_add_to_cart',
            product_id: productId,
            quantity: quantity,
            nonce: wc_add_to_cart_params_2.nonce
        },
        beforeSend: function() {
            $button.addClass('loading');
        },
        success: function(response) {
          repaintCart(response);
          $('header .cart-toggle').trigger('click');
        },
        complete: function() {
            $button.removeClass('loading');
        },
        error: function(xhr, status, error) {
            console.error('Add to Cart Error:', status, error);
        }
    });
});


});

